/**
 * Konsol portal: **login → daftar outlet**.
 *
 * ### ⭐ Dua pintu, dan layarnya jujur soal bedanya
 * Masuk lewat **kata sandi HQ** berarti boleh menulis master. Masuk lewat **PIN di outlet** berarti
 * hanya melihat — dan tombol yang menulis **tidak ditampilkan**, bukan ditampilkan lalu ditolak
 * server. Tombol yang selalu gagal mengajari orang bahwa penolakan itu wajar.
 */
import { useState } from 'react';

import { session } from './api/session';
import { Shell } from './layout/Shell';
import { Login } from './screens/Login';

export function App() {
  const [masuk, setMasuk] = useState(() => session() !== undefined);
  if (!masuk) return <Login onLogin={() => { setMasuk(true); }} />;
  return <Shell onLogout={() => { setMasuk(false); }} />;
}
